import NotePopupContainer from './NotePopupContainer';

export default NotePopupContainer;
